import { IS_JEST } from '../../helpers';

export const L10N = {
  LABEL_CHECK_IN: { id: 'common.label.check_in', defaultMessage: !IS_JEST ? 'Check-In' : undefined },
  LABEL_CHECK_OUT: { id: 'common.label.check_out', defaultMessage: !IS_JEST ? 'Check-Out' : undefined },
  LABEL_NIGHTS: { id: 'core.label.nights_stay' },
  LABEL_MIN_NIGHTS: { id: 'core.label.min_nights' },
  LABEL_MIN_NIGHTS_DEALS: { id: 'core.label.min_nights_deals' },
  LABEL_MIN_NIGHTS_REQUIRED: { id: 'core.label.min_nights_required' },
};
